export default {
  app: {
    name: 'NomadMate',
  },
  notFound: {
    title: 'Página não encontrada',
    description: 'A página que você procura não existe',
    goBack: 'Voltar ao início',
  },
  common: {
    loading: 'Carregando...',
    noData: 'Sem dados disponíveis',
    error: 'Algo deu errado, por favor tente novamente',
    retry: 'Tentar novamente',
    authExpired: 'Sessão expirada, faça login novamente',
    requestFailed: 'Falha na requisição',
    networkError: 'Erro de rede, verifique sua conexão',
    skipToContent: 'Ir para o conteúdo principal',
  },
  nav: {
    dashboard: 'Painel',
    visa: 'Visto',
    cost: 'Custo',
    timezone: 'Fuso horário',
    tax: 'Impostos',
    guide: 'Guia',
    login: 'Entrar',
  },
  footer: {
    about: 'Sobre',
    privacy: 'Privacidade',
    terms: 'Termos',
    copyright: '© 2026 NomadMate',
  },
  index: {
    hero: {
      title: 'Sua vida de nômade digital, organizada',
      subtitle: 'Plataforma completa de rastreamento de vistos, comparação de custos, coordenação de fusos horários, conformidade fiscal e guias de cidades',
      cta: 'Comece grátis',
      learnMore: 'Saiba mais',
    },
    features: {
      title: 'Funcionalidades',
      visa: { title: 'Rastreamento de visto', desc: 'Rastreie tipos de visto, validade e lembretes de renovação' },
      cost: { title: 'Comparar custos', desc: 'Compare custos de vida: hospedagem, alimentação, transporte e mais' },
      timezone: { title: 'Gestão de fusos', desc: 'Relógios multi-fuso e coordenação de reuniões entre fusos horários' },
      tax: { title: 'Assistente fiscal', desc: 'Consulta de regras fiscais transfronteiriças e alertas de residência' },
      guide: { title: 'Guia de cidades', desc: 'Guias detalhados de destinos nômades digitais no mundo' },
    },
    stats: {
      countries: 'Países',
      cities: 'Cidades',
      languages: 'Idiomas',
    },
  },
  login: {
    login: 'Entrar',
    register: 'Registrar',
    subtitle: 'Entre no NomadMate para gerenciar sua vida nômade',
    registerSubtitle: 'Crie uma conta para começar sua vida de nômade digital',
    email: 'E-mail',
    emailPlaceholder: 'seu@email.com',
    emailInvalid: 'Insira um endereço de e-mail válido',
    username: 'Nome de usuário',
    usernamePlaceholder: 'Insira seu nome de usuário',
    password: 'Senha',
    passwordPlaceholder: '••••••••',
    passwordTooShort: 'A senha deve ter pelo menos 6 caracteres',
    confirmPassword: 'Confirmar senha',
    confirmPasswordPlaceholder: 'Digite a senha novamente',
    passwordMismatch: 'As senhas não coincidem',
    loading: 'Entrando...',
    error: 'Falha ao entrar, tente novamente',
    orContinueWith: 'Ou continue com',
    noAccount: 'Não tem uma conta?',
    hasAccount: 'Já tem uma conta?',
  },
  dashboard: {
    welcome: 'Bem-vindo de volta, {name}',
    subtitle: 'Visão geral da sua vida nômade',
    stats: {
      activeVisas: 'Vistos ativos',
      daysUntilExpiry: 'Dias até expiração',
      citiesCompared: 'Cidades comparadas',
      timezones: 'Fusos rastreados',
    },
    expiryAlerts: 'Alertas de expiração de visto',
    noAlerts: 'Sem alertas de expiração',
    daysLeft: '{days} dias restantes',
    worldClocks: 'Relógios mundiais',
    quickActions: 'Ações rápidas',
    actions: {
      visa: 'Rastreamento visto',
      cost: 'Comparar custos',
      timezone: 'Fusos horários',
      tax: 'Assistente fiscal',
      guide: 'Guia cidades',
    },
    recentActivity: 'Atividade recente',
    noActivity: 'Sem atividade recente',
  },
  visa: {
    title: 'Gestão de vistos',
    subtitle: 'Rastreie e gerencie suas informações de visto',
    searchPlaceholder: 'Buscar por país...',
    allRegions: 'Todas as regiões',
    regions: {
      europe: 'Europa',
      asia: 'Ásia',
      americas: 'Américas',
      oceania: 'Oceania',
    },
    noCountries: 'Nenhum país encontrado',
    requirements: 'Requisitos',
    documents: 'Documentos exigidos',
    track: 'Rastrear este visto',
    applyUrl: 'Link de solicitação',
    myTracked: 'Meus vistos rastreados',
  },
  cost: {
    title: 'Custo de vida',
    subtitle: 'Compare o custo de vida entre diferentes cidades',
    selectCities: 'Selecionar cidades',
    selectHint: 'Selecione 2-4 cidades para comparar',
    compare: 'Comparar',
    selectedCount: '{count} cidades selecionadas',
    comparison: 'Comparação',
    category: 'Categoria',
    nomadScore: 'Pontuação nômade',
    budgetFinder: 'Buscador de orçamento',
    budgetPlaceholder: 'Insira o orçamento mensal',
    findCities: 'Encontrar cidades',
    aiSuggestion: 'Sugestões IA em breve',
  },
  timezone: {
    title: 'Gestão de fusos horários',
    subtitle: 'Gerencie horários e reuniões em múltiplos fusos',
    addTimezone: 'Adicionar fuso horário',
    noTimezones: 'Clique acima para adicionar fusos horários',
    meetingScheduler: 'Agendador de reuniões',
    meetingHint: 'Selecione os fusos horários dos participantes para encontrar o melhor horário',
    findMeeting: 'Encontrar horário de reunião',
    finding: 'Buscando...',
    bestTime: 'Melhor horário',
    workingOverlap: 'Sobreposição horário de trabalho',
  },
  tax: {
    title: 'Assistente fiscal',
    subtitle: 'Cálculo fiscal transfronteiriço e conformidade',
    rules: 'Regras fiscais',
    selectCountry: 'Selecionar país',
    thresholdDays: 'Limite de dias de residência',
    days: 'dias',
    taxRates: 'Alíquotas fiscais',
    reportingRequirements: 'Obrigações de declaração',
    importantDates: 'Datas importantes',
    residenceTracker: 'Rastreamento de dias de residência',
    noResidenceDays: 'Nenhum dia de residência registrado',
    riskIndicator: 'Indicador de risco fiscal',
    noRiskData: 'Sem dados de risco disponíveis',
    countries: {
      portugal: 'Portugal',
      thailand: 'Tailândia',
      spain: 'Espanha',
      germany: 'Alemanha',
      estonia: 'Estônia',
      georgia: 'Geórgia',
      croatia: 'Croácia',
      mexico: 'México',
      colombia: 'Colômbia',
      indonesia: 'Indonésia',
      japan: 'Japão',
      southKorea: 'Coreia do Sul',
      unitedKingdom: 'Reino Unido',
      unitedStates: 'Estados Unidos',
    },
  },
  guide: {
    title: 'Guia de cidades',
    subtitle: 'Guias de destinos nômades digitais no mundo',
    allContinents: 'Todos',
    noCities: 'Nenhuma cidade encontrada',
    backToList: 'Voltar à lista',
    internetQuality: 'Qualidade da Internet',
    safetyRating: 'Classificação de segurança',
    climate: 'Clima',
    communitySize: 'Tamanho da comunidade',
    coworkingSpaces: 'Espaços de coworking',
    noCoworking: 'Nenhum espaço de coworking disponível',
    day: 'dia',
  },
  settings: {
    title: 'Configurações',
    subtitle: 'Gerencie sua conta e preferências',
    profile: 'Perfil',
    username: 'Nome de usuário',
    email: 'E-mail',
    saveProfile: 'Salvar perfil',
    saving: 'Salvando...',
    language: 'Idioma',
    notifications: 'Notificações',
    visaExpiryNotif: 'Lembretes de expiração de visto',
    taxReminderNotif: 'Lembretes fiscais',
    appearance: 'Aparência',
    light: 'Claro',
    dark: 'Escuro',
    baseTimezone: 'Fuso horário base',
    dangerZone: 'Zona de perigo',
    dangerDesc: 'Estas ações são irreversíveis, prossiga com cautela',
    deleteAccount: 'Excluir conta',
    confirmDelete: 'Confirmar exclusão da conta',
    confirmDeleteDesc: 'Isso excluirá permanentemente sua conta e todos os dados. Esta ação não pode ser desfeita.',
    cancel: 'Cancelar',
    confirm: 'Excluir',
  },
  about: {
    title: 'Sobre',
    subtitle: 'NomadMate - Assistente para nômades digitais',
    version: 'Versão',
    versionNumber: '1.0.0',
    description: 'NomadMate é um assistente projetado para nômades digitais, oferecendo gestão de vistos, comparação de custo de vida, gestão de fusos horários, cálculo fiscal e guias de cidades para facilitar sua vida nômade global.',
    openSource: 'Agradecimentos open source',
    openSourceDesc: 'Este projeto é construído sobre os seguintes excelentes projetos open source',
    contact: 'Entre em contato',
    support: 'Suporte técnico',
    feedback: 'Feedback',
    privacyPolicy: 'Política de privacidade',
    terms: 'Termos de serviço',
  },
}
